.grid {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}

.card {
  flex: 1 1 calc(20% - 11.2px);
  min-width: 160px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 22px 22px 18px;
  background: var(--surface);
  border-radius: var(--radius);
  min-height: 156px;
  animation: fadeUp 0.4s ease both;
  animation-delay: calc(var(--i, 0) * 60ms);
}

.label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--soft);
}

.value {
  font-family: var(--font-display);
  font-size: clamp(2rem, 3vw, 2.7rem);
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  color: var(--text);
  letter-spacing: -0.01em;
}

.sub {
  font-size: 0.88rem;
  color: var(--muted);
  min-height: 18px;
}

.delta {
  margin-top: auto;
  padding-top: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  border-top: 1px solid var(--border);
  color: var(--muted);
}

.delta.up    { color: var(--up); }
.delta.down  { color: var(--down); }
.delta.flat  { color: var(--muted); }

.prev {
  font-weight: 400;
  opacity: 0.65;
}

/* Skeleton loading state */
.skeleton {
  border-color: var(--border);
  background: linear-gradient(90deg, var(--surface) 25%, var(--surface-2) 50%, var(--surface) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  animation-delay: 0s;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (max-width: 640px) {
  .card {
    min-height: 128px;
  }

  .value {
    font-size: 1.8rem;
  }
}
